"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../services");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StyledColumn = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)(props => (0, _styledComponents.css)`
  h2{
    font-size: ${props.smallFont}px;
    line-height: ${props.smallLineHeight}px;
   ${_r10SourceLibrary.Mixins.respondTo.md(` 
      font-size:  ${props.largeFont}px; 
      line-height: ${props.largeLineHeight}px;
    `)}
  }
`);
const BroadbandSummary = () => {
  const title = _services.locale.localeString('Summary.TitleBroadband');
  const subtitle = _services.locale.localeString('Summary.SubtitleBroadband');
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(StyledColumn, {
    smallFont: 24,
    largeFont: 30,
    smallLineHeight: 30,
    largeLineHeight: 37.5
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: title,
    justify: 'center',
    weight: 3,
    size: 2,
    id: "summary-title"
  })))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(StyledColumn, {
    smallFont: 16,
    largeFont: 20,
    smallLineHeight: 24,
    largeLineHeight: 30
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: subtitle,
    justify: 'center',
    size: 1,
    id: "summary-subtitle"
  })))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Loader, {
    id: "summary-loader"
  }));
};
var _default = BroadbandSummary;
exports.default = _default;